/* Shopify Markets localization picker.
   Opens the country/currency dropdown and submits the {% form 'localization' %},
   so the storefront reloads with real presentment-currency prices (money filter)
   and checkout charges in that currency. No client-side rates — Shopify converts. */
(function () {
  "use strict";

  function pickers() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-currency-picker]"));
  }

  function closeAll() {
    pickers().forEach(function (p) {
      var menu = p.querySelector("[data-currency-menu]");
      var toggle = p.querySelector("[data-currency-toggle]");
      var chev = p.querySelector("[data-currency-chevron]");
      if (menu) menu.hidden = true;
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      if (chev) chev.classList.remove("rotate-180");
    });
  }

  function init() {
    pickers().forEach(function (picker) {
      var toggle = picker.querySelector("[data-currency-toggle]");
      var menu = picker.querySelector("[data-currency-menu]");
      var chev = picker.querySelector("[data-currency-chevron]");
      var input = picker.querySelector("[data-currency-input]");
      var form = picker.querySelector("form") || picker.closest("form");

      if (toggle) toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        var isOpen = menu && !menu.hidden;
        closeAll();
        if (menu && !isOpen) {
          menu.hidden = false;
          toggle.setAttribute("aria-expanded", "true");
          if (chev) chev.classList.add("rotate-180");
        }
      });

      picker.querySelectorAll("[data-currency-option]").forEach(function (opt) {
        opt.addEventListener("click", function () {
          var code = opt.getAttribute("data-currency-option");
          if (input) input.value = code;
          if (form) {
            if (typeof form.requestSubmit === "function") form.requestSubmit();
            else form.submit();
          }
        });
      });
    });

    document.addEventListener("click", closeAll);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
